<div *ngIf="type() == 'vertical'">

  <!-- TEMPLATE VERICALE -->
  <div class="app-card-box p-none h-100"
       *ngIf="!skeleton() && template()"
       [routerLink]="['/template-detail', template()?.id]"
       [ngClass]="{'scroll-item-width': !fullWidth(), 'w-100': fullWidth()}">
    <div class="img-bg app-border-radius top"
         style="height: 110px;"
         [appBackgroundImage]="template()?.imageUrl"></div>

    <div class="p-sm d-flex flex-column ion-justify-content-between">
      <div class="rubrica-title"
           [innerHTML]="template()?.body | translation :'title'"></div>
      <div class="d-flex ion-justify-content-between mt-sm ion-align-items-center">
        <div class="ts-small-bold pt-sm text-azzurro-500 read-more">
          <div>Scopri di più</div>
          <div class="material-symbols-outlined">chevron_right</div>
        </div>
        <div>
          <app-trackable-items type="template" [entity]="template()"></app-trackable-items>
        </div>
      </div>
    </div>

  </div>

</div>

<div *ngIf="type() == 'horizontal'">

  <div *ngIf="!skeleton() && template()"
       [routerLink]="['/template-detail', template()?.id]"
       class="app-card-box d-flex gap-4 p-md w-100">

    <div [appBackgroundImage]="template()?.imageUrl"
         class="rubrica-image__horizontal"></div>

    <div>
      <div class="rubrica-title__horizontal"
           [innerHTML]=" template()?.body | translation: 'title' "></div>

      <div class="d-flex ion-justify-content-between mt-sm ion-align-items-center">
        <div class="ts-small-bold text-azzurro-500 read-more">
          <div>Scopri di più</div>
          <div class="material-symbols-outlined">chevron_right</div>
        </div>
        <app-trackable-items type="template" [entity]="template()"></app-trackable-items>
      </div>
    </div>


  </div>
</div>

